import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { ReactNode } from 'react';
import Icon from '../../IconSvg/Icon';

export type LelyCheckboxProps = Omit<
  MuiCheckboxProps,
  'checkedIcon' | 'children' | 'icon' | 'indeterminateIcon'
> & {
  'data-testid'?: string;
  children?: ReactNode;
  dense?: boolean;
  label?: ReactNode;
};

const getDefaultCheckboxId = (labelContent: ReactNode) => {
  if (typeof labelContent === 'string' || typeof labelContent === 'number') {
    return String(labelContent);
  }

  return undefined;
};

function LelyCheckbox({
  children,
  dense,
  id,
  label,
  name,
  'data-testid': dataTestId,
  ...props
}: LelyCheckboxProps) {
  const labelContent = label ?? children;
  const checkboxId = id ?? getDefaultCheckboxId(labelContent);
  const checkboxName = name ?? getDefaultCheckboxId(labelContent);

  const checkbox = (
    <MuiCheckbox
      {...props}
      checkedIcon={<Icon name="lely-icon-check" />}
      data-dense={dense || undefined}
      data-testid={dataTestId}
      icon={<span />}
      id={checkboxId}
      indeterminateIcon={<Icon name="lely-icon-minus" />}
      name={checkboxName}
    />
  );

  if (labelContent) {
    return (
      <FormControlLabel
        control={checkbox}
        disableTypography
        sx={{
          minWidth: 0,
          width: '100%',

          '& .MuiFormControlLabel-label': {
            flex: 1,
            minWidth: 0,
          },
        }}
        label={
          typeof labelContent === 'string' || typeof labelContent === 'number' ? (
            <Typography
              variant="xs"
              component="span"
              data-testid="checkbox-label"
              sx={(theme) => ({
                fontFamily: theme.lelyFontFamily.UBUNTU,
                minWidth: 0,
                overflowWrap: 'anywhere',
              })}
            >
              {labelContent}
            </Typography>
          ) : (
            labelContent
          )
        }
      />
    );
  }

  return checkbox;
}

export default LelyCheckbox;